export default __webpack_public_path__ + "static/media/Rent-Normans-Guitar.5899da41.jpg";